import {
    infoColor,
    lightGrayColor,
    grayColor,
    lightBlueColor,
    successColor,
    warningColor,
    dangerColor,
    defaultFont,
    container,
    primaryColor, red50, red500, green500, green50, orange50, orange500, greyishBlue100
} from "../../main";
import filterMenuStyle from "assets/jss/components/filterMenuStyle";

const defaultProductListFont = {
    fontWeight: "400",
    fontSize: "16px"
};

const defaultProductListXsFont = {
    fontWeight: "300",
    fontSize: "12px"
};

const defaultBorder = {
    borderWidth: "1px 0px 0px 0px",
    borderStyle: "solid",
    borderColor: lightGrayColor,
};

const defaultCategoryChipSize = {
    maxWidth: "420px",
};

const defaultStock = {
    ...defaultProductListFont,
    color: "#fff",
    margin: "2px",
    fontSize: "14px",
    fontWeight: "bold",
    padding: "2px 8px 2px 8px",
    borderRadius: "48px",
};

const stockBadgeDefault =  {
    width: "8px",
    height: "8px",
    borderRadius: "2px",
    display: "block",
    marginRight: "4px",
};

const listStyle = theme => ({
    ...filterMenuStyle(theme),
    containerWithSidebar: {
        [theme.breakpoints.up("md")]: {
            marginLeft: "240px",
        }
    },
    container: {
        ...container,
        ...defaultFont
    },
    mainActionsContainer: {
        textAlign: "right",
        "& div": {
            width: "100%"
        }
    },
    card: {
        minHeight: window.innerHeight * 0.94
    },
    titleContainer: {
        display:"flex",
        alignItems: "center"
    },
    tableWrapper: {
        overflowX: "auto",
        border: `1px solid ${greyishBlue100}`,
        borderRadius: "8px",
        "& td": {
            borderBottomColor: greyishBlue100,
            padding: "10px 0",
        },
        "& td:first-of-type": {
            paddingLeft: "20px",
        },
    },
    searchInput: {
        ...defaultProductListFont,
        width: "35vh",
        marginTop: "20px",
        marginBottom: "10px",
        "&:focus": {
            borderColor: infoColor,
        },
    },
    tableCell:{
        padding: "10px 0 10px 0 !important",
        height: "100px",
    },
    tableRowHover: {
        "&:hover": {
            backgroundColor: "whitesmoke !important",
            cursor: "pointer"
        }
    },
    tableTitle: {
        marginLeft: "-10px",
        fontSize:"18px"
    },
    gridItemNoPadding: {
        padding: "0px"
    },
    colorBar: {
        backgroundColor: successColor,
    },
    colorSwitchBase: {
        color: successColor,
        '&$colorChecked': {
            color: successColor,
            '& + $colorBar': {
                backgroundColor: successColor,
            },
        },
    },
    colorChecked: {
        color: dangerColor,
        '&$colorChecked': {
            color: dangerColor,
            '& + $colorBar': {
                backgroundColor: dangerColor,
            },
        },
    },
    filterSelectedContainer: {
        ...defaultBorder,
        display: "flex",
        flexWrap: "wrap",
    },
    filterSelectedItem: {
        ...defaultProductListFont,
        margin: "10px 0px 10px 10px ",
        backgroundColor: infoColor,
        color: "#FFF",
    },
    resetBar:{
        ...defaultBorder,
    },
    resetSelected: {
        width:"130px",
        verticalAlign:"center",
        align: "center",
        margin:"10px",
        padding:"7px",
    },
    actionsContainer: {
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap",
        gap: "12px",
    },
    sync: {
        marginLeft: "10px",
        display: "flex",

        "& svg":{
            marginRight: "10px"
        }
    },
    addProduct: {
        display: "flex",

        "& svg":{
            marginRight: "10px"
        }
    },
    notUsedProduct: {
        marginLeft: "10px",
        display: "flex",
        borderColor: warningColor
    },
    syncing: {
        animation: "slide infinite 2s linear"
    },
    "@keyframes slide": {
        "from": {transform: "rotate(360deg)"},
        "to": {transform: "rotate(0deg)"},
    },
    action: {
        padding: "15px",
    },
    myOffers: {
        border: 'none !important',
        marginRight: '10px',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
    },
    disableElementsContainer: {
        display: 'inline-flex',
    },
    actionSelect:{
        ...defaultProductListFont,
        minWidth: "102px"
    },
    checkbox: {
        color: lightGrayColor,
        "&$checked": {
            color: infoColor,
        },
    },
    checked: {},
    image: {
        verticalAlign: "middle",
        maxWidth: "60px",
        maxHeight: "60px"
    },
    imagePlaceholder: {
        verticalAlign: "middle",
        fontSize: "60px"
    },
    brandCell: {
        ...defaultProductListFont,
    },
    priceCell: {
        paddingLeft: "5px",
    },
    imageCell: {
        textAlign: "center",
    },
    name: {
        ...defaultProductListFont,
        display: "-webkit-box",
        "-webkit-line-clamp": 3,
        "-webkit-box-orient": "vertical",
        overflow: "hidden"
    },
    nameInfos:{
        ...defaultProductListXsFont,
    },
    category: {
        ...defaultProductListFont,
        ...defaultCategoryChipSize,
        backgroundColor: primaryColor,
        color: "#FFFFFF",
        margin: "5px 5px 5px 0px"
    },
    categoryDraft: {
        ...defaultProductListFont,
        ...defaultCategoryChipSize,
        backgroundColor: lightBlueColor,
        color: "#FFFFFF",
        margin: "5px 5px 5px 0px"
    },
    price : {
        ...defaultProductListFont
    },
    xsPrice: {
        ...defaultProductListXsFont
    },
    stockStatus :{
        display: "flex",
        justifyContent: "flex-start",
        flexDirection: "column",
        maxWidth: "160px"
    },
    status: {
        ...defaultProductListFont,
        border: "1px solid black",
        margin: "5px 0px 5px 0px",
        maxWidth: "160px"
    },
    statusOff: {
        ...defaultProductListFont,
        margin: "5px 0px 5px 0px",
        padding: "10px",
        maxWidth: "160px"
    },
    stock :{
        display: "flex",
        justifyContent: "flex-start",
        flexDirection: "row",
        flexWrap: "wrap",
        marginBottom: "5px",
        maxHeight:"90px !important",
        overflowY: "auto",
        "&::-webkit-scrollbar": {
            WebkitAppearance: "none",
        },
        "&::-webkit-scrollbar:vertical" :{
            width: "11px",
        },
        "&::-webkit-scrollbar:horizontal": {
            height: "11px",
        },
        "&::-webkit-scrollbar-thumb": {
            borderRadius: "8px",
            border: "2px solid white", /* should match background, can"t be transparent */
            backgroundColor: "rgba(0, 0, 0, .5)",
        },
        "& .MuiChip-label": {
            display: "flex",
            alignItems: "center",
        }
    },
    inStock: {
        ...defaultStock,
        backgroundColor: green50,
        borderColor: green50,
        color: green500,
    },
    stockBadgeOnline: {
        ...stockBadgeDefault,
        background: green500,
    },
    stockBadgeOffline: {
        ...stockBadgeDefault,
        background: red500,
    },
    middleStock: {
        ...defaultStock,
        backgroundColor: orange50,
        borderColor: orange50,
        color: orange500,
    },
    noStock: {
        ...defaultStock,
        backgroundColor: red50,
        borderColor: red50,
        color: red500,
    },
    validated:{
        paddingLeft: '15px',
        color: successColor,
    },
    notValidated: {
        paddingLeft: '15px',
        color: dangerColor,
    },
    showVariationIcon: {
        cursor: "pointer",
        fontSize: "28px",
        paddingLeft: "5px",
        "&:hover": {
            color: primaryColor,
        },
        verticalAlign: "middle"
    },
    customSelectActions: {
        ...defaultProductListFont,
        borderRadius: "10px",
        height: "45px",
        width: "102px",
        textAlign: "center",
        color: primaryColor
    },
    editIcon:{
        marginRight: "12px",
        color: infoColor,
        cursor: "pointer"
    },
    footer: {
        display: "flex",
        alignItems: "center",
        backgroundColor: "transparent",
        marginBottom: "20px"
    },
    pagination: {
        marginTop:"20px",
        marginRight: "auto !important",
        marginLeft: "auto !important"
    },
    tableCellNoResult: {
        ...defaultProductListFont,
        textAlign: "center",
        fontWeight: "bold",
        verticalAlign: "middle",
        marginTop: "20px"
    },
    submitLoading: {
        marginLeft: "5px",
        color: "#FFFFFF"
    },
    loadingBar: {
        position: "fixed"
    },
    totalContainer: {
        ...defaultProductListFont,
        color: grayColor,
        textAlign: "right",
        padding: "15px",
        display: "flex",
        justifyContent: "flex-end",
    },
    totalSpan: {
        display: "flex",
        alignItems: "center",
        marginRight: "10px"
    },
    beatLoader: {
        position: "absolute",
        right: "30px",
        margin: "0 auto",
        top: "77px",
        display: "flex",
        justifyContent: "center"
    },
    propagateLoader: {
        position: "absolute",
        left: "0",
        right: "0",
        margin: "0 auto",
        top: "58%",
        display: "flex",
        justifyContent: "center"
    },
    submitLoadingSwitch:{
        color: "#DDD"
    },
    dialogSearch:{
        width: "100%",
        padding: "10px",
    },
    dialogContentLoader: {
        width: "100%",
        textAlign: "center",
    },
    categorieListItem: {
        padding: 0,
        cursor: "pointer"
    },
    categoryNameListItem:{
        padding: 0,
        "&:hover": {
            "& span": {
                color: infoColor
            }
        }
    },
    categoryNameListItemSelected: {
        "& span": {
            color: infoColor
        }
    },
    childrenCategories: {
        marginLeft: 30,
    },
    dialogTitle: {
        textAlign: "center"
    },
    dialogContent: {
        padding: "0 !important",
    },
    inviteSelectField: {
        width: "100%",
        height: "43px",
        border: `1px solid ${lightGrayColor}`,
        borderRadius: "4px",
        marginBottom: "15px",
        padding: "10px"
    },
    dialogContentChild: {
        padding: "0 24px 24px",
    },
    selectTotalContainer: {
        background: "rgba(241,243,244,0.871)",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        padding: "6px 16px"
    },
    selectTotalButton:{
        textTransform: "none",
        color: infoColor,
    },
    errorOnPush : {
        animation: "$triggerBorder infinite 1.4s linear",
        width: "10px",
        height: "10px",
        display: "block",
        borderRadius: "5px",
        background: dangerColor,
        marginLeft: "37%",
        marginTop: "10px",
    },
    "@keyframes triggerBorder" : {
        from :  {boxShadow: `0 0 0 0 ${dangerColor}`},
        to: {boxShadow: "0 0 0 9px rgba(234,75,70,0)"}
    },
    lineSelected: {
        backgroundColor: '#f5f9ff',
        borderColor: '#027eff',
    },
    lineLink: {
        textDecoration: 'none',
        color: '#000'
    }
});

export default listStyle;
